import request from "../utils/request.js"
// 获取政策列表
export function getPolicyList(params) {
    return request({
        url: "/policy/list",
        method: "post",
        data: params,
    })
}
// 获取政策详情
export function getPolicyDetail(params) {
    return request({
        url: "/policy/detail/"+params,
        method: "get",
        // params: params,
    })
}
// 获取业务列表
export function getProcessList(params) {
    return request({
        url: "/process/list",
        method: "post",
        data: params,
    })
}
// 获取业务列表
export function getDemandProcessList(params) {
    return request({
        url: "/process/demandList?secondCategoryId=" + params,
        method: "get",
        // data: params,
    })
}
// 获取业务详情以及资源
export function getProcessDetail(params) {
    return request({
        url: "/process/detail/"+params,
        method: "get",
        // params: params,
    })
}

